export enum FormState {
  Stars = 'Stars',
  ExamCenter = 'ExamCenter',
  StudyType = 'StudyType',
  DataTransferForm = 'DataTransferForm',
}
